<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add custom data</span>
  </a>
</ng-template>

<smart-table [headers]="headers"
             [source]="source"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [navigate]="editPath">
  <ng-template smartTableColumn="id" let-item>
    <td>
      <span class="font-weight-medium">{{ item.id }}</span> <br>

      <!--      <ng-container *ngIf="item.active; else notActive">-->
      <!--        <span class="small">{{ item.email }}</span>-->
      <!--      </ng-container>-->
      <!--      <ng-template #notActive>-->
      <!--        <small class="text-muted">{{ item.email }}</small>-->
      <!--      </ng-template>-->
    </td>
  </ng-template>

  <ng-template smartTableColumn="key" let-item>
    <td>
      <span>{{ item.key }}</span>
    </td>
  </ng-template>

  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="json" let-item>
    <td>
      <ng-container *ngIf="item.json">
        <button class="btn-link p-0 m-0 border-dotted text-decoration-none"
                (click)="toggleJson($event, item)">toggle JSON</button><br>
        <ngx-json-viewer *ngIf="item.show" [json]="item.json | parseJSON" [expanded]="false"></ngx-json-viewer>
      </ng-container>
    </td>
  </ng-template>

</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>
